<div class="shimmer-container" [class]="className" [attr.data-testid]="testId">
  <div class="shimmer-table">
    <!-- Shimmer Rows Only (No Header) -->
    <div
      *ngFor="let row of shimmerRows; trackBy: trackByIndex"
      class="shimmer-row"
      [style.grid-template-columns]="getGridTemplateColumns()"
    >
      <div
        *ngFor="let column of columns; trackBy: trackByIndex"
        class="shimmer-cell shimmer-bar"
        [ngClass]="getColumnClass(column)"
      ></div>
    </div>
  </div>
</div>
